import { Component, OnInit, input, output } from '@angular/core';
import BeefreeSDK from '@beefree.io/sdk';
import { BeePluginCommentPayload, BeePluginError, IBeeConfig, IEntityJson } from '@beefree.io/sdk/dist/types/bee';
import { debugLogger } from '@common-helpers/debug-logger';
export interface IToken {
    access_token: string;
    v2: boolean;
}
export interface IEntityContentJson {
    page: IEntityJson;
    comments: {
        [commentId: string]: BeePluginCommentPayload;
    };
}
export interface IBeefreeTemplateEditorConfig {
    uid: string;
    token: IToken;
    config?: Omit<IBeeConfig, 'container'>;
    templateJson: any;
}

@Component({
    selector: 'beefree-template-editor',
    templateUrl: './beefree-template-editor.component.html',
    styleUrls: ['./beefree-template-editor.component.scss'],
    imports: []
})
export class BeefreeTemplateEditorComponent implements OnInit {
    beeFree: BeefreeSDK | null = null;

    config = input.required<IBeefreeTemplateEditorConfig>();
    templateSaved = output<{ json: string; html: string }>();

    async ngOnInit(): Promise<void> {
        let config = this.config();
        if (config) {
            this.beeFree = new BeefreeSDK(config.token);
        }
    }

    async ngAfterContentInit(): Promise<void> {
        if (!this.beeFree) {
            return;
        }
        debugLogger.info(`Starting beefree with config:`);
        debugLogger.info('this.config', this.config);
        debugLogger.info('document.querySelector(\'#beefree-sdk-container\')', document.querySelector('#beefree-sdk-container'));
        debugLogger.info('this.beeFree.start', this.beeFree.start);

        //    await this.beeFree.getToken(environment.beeFree.clientId, environment.beeFree.clientSecret);
        let beeConfig = this.config();
        let config = {
            uid: beeConfig.uid,
            container: 'beefree-sdk-container',
            language: beeConfig?.config?.language || 'en-US',
            autosave: 0,
            onSave: (jsonFile: string, html: string): void => {
                debugLogger.info('onSave', [jsonFile, html]);
                this.templateSaved.emit({ json: jsonFile, html });
            },
            onSaveAsTemplate: (jsonFile: string): void => {
                debugLogger.info('onSaveAsTemplate', jsonFile);
            },
            onSend: (htmlFile: string): void => {
                debugLogger.info('onSend', htmlFile);
            },
            onError: (errorMessage: BeePluginError): void => {
                debugLogger.info('onError ', errorMessage);
            }
        };

        if (beeConfig.config) {
            config = Object.assign({}, beeConfig.config, config);
        }

        await this.beeFree.start(config, beeConfig.templateJson);
    }

    async save(): Promise<void> {
        if (!this.beeFree) {
            return;
        }
        await this.beeFree.save();
    }

    async ngOnDestroy(): Promise<void> {}
}
